
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CertificateHistoryTimeline from './CertificateHistoryTimeline';
import { FileText } from "lucide-react";
import { CertificateMetadata } from '@/types/certification';

interface CertificateHistoryProps {
  certificates: CertificateMetadata[];
  studentId: number;
}

const CertificateHistory = ({ certificates, studentId }: CertificateHistoryProps) => {
  const sortedCertificates = [...certificates].sort((a, b) => 
    new Date(b.issueDate).getTime() - new Date(a.issueDate).getTime()
  );

  if (sortedCertificates.length === 0) {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="text-center py-8">
            <FileText className="h-16 w-16 mx-auto text-muted-foreground" />
            <h3 className="mt-4 text-lg font-medium">No Certificates Found</h3>
            <p className="mt-2 text-muted-foreground">
              This student hasn't been issued any certificates yet.
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <Tabs defaultValue={sortedCertificates[0].id}>
          <TabsList className="w-full justify-start">
            {sortedCertificates.map(cert => (
              <TabsTrigger key={cert.id} value={cert.id} className="flex-1">
                {cert.programTitle}
              </TabsTrigger>
            ))}
          </TabsList>
          
          {sortedCertificates.map(cert => (
            <TabsContent key={cert.id} value={cert.id}>
              <CertificateHistoryTimeline certificate={cert} />
            </TabsContent>
          ))}
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default CertificateHistory;
